export enum MIP_DRAFT_STEPS {
	GENERAL = 'GENERAL',
	PERSONAL = 'PERSONAL',
	KYC = 'KYC',
	SECURITIES = 'SECURITIES',
	CONTRACTS = 'CONTRACTS',
	SCHEDULE = 'SCHEDULE',
	PREVIEW = 'PREVIEW',
	INVESTORS = 'INVESTORS',
	COLLABORATE = 'COLLABORATE',
	SUMMARY = 'SUMMARY',
}

export enum MIP_DRAFT_STEPS_STATUS {
	ERROR_MISSING_DATA = 'ERROR_MISSING_DATA',
	ERROR_INVALID_DATA = 'ERROR_INVALID_DATA',
	WARNING = 'WARNING',
	VALID = 'VALID',
	ERROR_MAX_LENGTH = 'ERROR_MAX_LENGTH',
}
